import { defineMessages } from 'react-intl';

export default defineMessages({
    yourEmployerHeader: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.yourEmployerHeader',
        defaultMessage: 'Your Employer/Affiliation:'
    },
    employerNotListed: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.employerNotListed',
        defaultMessage: 'My employer or affiliation is not listed'
    },
    organizationName: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.organizationName',
        defaultMessage: 'Organization Name: {organizationName}'
    },
    gpcCode: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.gpcCode',
        defaultMessage: 'GPC Code: {gpcCode}'
    },
    payPeriod: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.payPeriod',
        defaultMessage: 'Pay Period: {payPeriod}'
    },
    paypointNumber: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.paypointNumber',
        defaultMessage: 'Paypoint Number: {paypointNumber}'
    },
    paypointCommentsConsumer: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.paypointCommentsConsumer',
        defaultMessage: 'Comments: {paypointCommentsConsumer}'
    },
    paypointEligibilityComments: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.paypointEligibilityComments',
        defaultMessage: 'Paypoint Eligibility Comments: {paypointEligibilityComments}'
    },
    paypointEligibilityCommentsConsumer: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.paypointEligibilityCommentsConsumer',
        defaultMessage: 'Paypoint Eligibility Comments: {paypointCommentsConsumer}'
    },
    paypointName: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.paypointName',
        defaultMessage: 'Paypoint Name: {paypointName}'
    },    
});
